const projects: IProjectInfo[] = [
  {
    id: "project-sss",
    imgLength: 11,
    hasVideo: false,
    title: "스마트 역 안전진단관리 통합 시스템",
    numOfPeople: 3,
    deployURL: "https://personal-u76txsk2.outsystemscloud.com/SSS_Company/",
    summary: "Low-Code 기반 역 시설물 안전진단 통합 관리 플랫폼",
    tasks: [
      "팀장",
      "개발 진행 상황 관리",
      "ERD 작성 주도 및 모듈 분리",
      "공통 컴포넌트 및 공통 액션 분리",
      "총 74개의 작업 중 44개 작업 수행",
      "AI 이미지 분석을 활용한 당일 점검 결과 모니터링 업무 자동화",
    ],
    result: "우수 프로젝트 선정 - ㈜글로벌아카데미",
    skills: ["Outsystems", "Brity RPA"],
    startDate: "2026.06.15",
    endDate: "2026.07.15",
  },
  {
    id: "project-switchon-recipe",
    imgLength: 7,
    hasVideo: false,
    title: "스위치온 레시피",
    numOfPeople: 1,
    deployURL:
      "https://play.google.com/store/apps/details?id=com.dltjrrbs2020.switchonrecipe&hl=ko",
    summary: "AI 기반 스위치온 다이어트 레시피 생성 앱",
    tasks: [
      "ERD 작성",
      "공통 컴포넌트 및 공통 액션 분리",
      "Gemini API 기반 스위치온 다이어트 주차별 맞춤 레시피 생성",
      "Supabase Cron 기반 월별 미사용 레시피 이미지 자동 정리",
      "Tanstack Query를 활용해, Fetch 에러 발생 시 이전 캐싱 데이터를 표시하여 UX 개선",
      "앱 내 문의 및 Sentry를 통한 지속적인 프로덕션 버그 수정",
    ],
    result: "총 설치 수 1,000회 및 DAU/MAU 23% 달성",
    resultDetail: "앱 출시 후 180일 기준",
    skills: ["React-Native", "Expo", "TypeScript", "Zustand", "Tanstack Query", "Sentry"],
    startDate: "2025.07.14",
    endDate: "2025.08.26",
  },
  {
    id: "project-pulgo",
    imgLength: 8,
    hasVideo: false,
    title: "풀고",
    numOfPeople: 5,
    deployURL: "https://pulgo.netlify.app/",
    githubURL: "https://github.com/YongJaeHyun/Pulgo",
    summary: "실시간 온라인 시험·문제 공유 플랫폼",
    tasks: [
      "팀원",
      "ERD 작성 주도",
      "팔로잉 기능 구현",
      "문제·문제집 필터링 및 검색 구현",
      "Supabase Trigger 기반 포인트 등급 시스템 구현",
      "Supabase Realtime 기반 실시간 알림 기능 구현 (팔로워, 포인트, 시험 초대, 댓글)",
      "실시간 다중 사용자 온라인 시험 기능 구현",
    ],
    result: "DB Trigger·Function 이해도 향상 및 WebSocket 기반 실시간 데이터 처리 경험",
    skills: ["Vue", "TailwindCSS", "Pinia", "Supabase", "Netlify"],
    startDate: "2025.01.13",
    endDate: "2025.02.04",
  },
  {
    id: "project-portfolio",
    imgLength: 5,
    hasVideo: false,
    title: "포트폴리오 웹사이트",
    numOfPeople: 1,
    githubURL: "https://github.com/YongJaeHyun/YongJaeHyun.github.io",
    deployURL: "https://yongjaehyun.github.io/",
    summary: "AI를 사용하지 않고 만든 포트폴리오 사이트",
    tasks: [
      "반응형 웹사이트로 제작",
      "Context API를 활용하여 슬라이드 기능 캡슐화",
      "Custom Hook을 통해 Typing 애니메이션 구현",
      "마우스 위치에 따라 입체감 있게 보이도록 하는 3D 카드 컴포넌트 제작",
    ],
    result: "라이브러리 사용을 최소화하고 직접 구현하여, React 활용 역량 강화",
    skills: ["React", "TS", "TailwindCSS", "Github Pages", "Github Action"],
    startDate: "2024.02.09",
    endDate: "2024.02.13",
  },
  {
    id: "project-workable",
    imgLength: 13,
    hasVideo: true,
    title: "장애인 구인구직 웹사이트 - 워커블",
    numOfPeople: 5,
    githubURL:
      "https://github.com/YongJaeHyun/job-search-web-for-disabled-person?tab=readme-ov-file",
    deployURL: "https://f5-workable.github.io/",
    summary: "장애인과 기업 사이에서 구인구직 중개를 해주는 웹사이트",
    tasks: [
      "팀장",
      "프론트엔드 전체 소스코드 관리 및 CI/CD 관리",
      "장애인과 기업 양측의 홈, 검색, 공고 상세, 북마크, 희망 근무지, 지원 현황 페이지 개발",
      "공공데이터 활용",
    ],
    result: "장려상 수상 - (재)포항테크노파크",
    skills: ["React", "JS", "TailwindCSS", "Github Pages"],
    startDate: "2023.05.02",
    endDate: "2023.05.30",
  },
];

export default projects;
